import { createBrowserRouter, Navigate } from 'react-router-dom';

import Loadable from '@common/components/loadable';
import { lazyWithRetry } from '@common/utils/lazy-retry';
import { PartnerProtectedRoute } from '../components/authentication/partner-protected-route';
import { AppShell } from '../layout/app-shell';
import Login from '../pages/login';
import MultiAccount from '@common/pages/login/multi-account';

const AgentDashboard = Loadable(lazyWithRetry(() => import('../pages/agents')));

const AgentBuilder = Loadable(lazyWithRetry(() => import('../pages/agent-builder')));

const ProfilePage = Loadable(lazyWithRetry(() => import('../pages/profile')));

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/my/accounts',
    element: <MultiAccount />,
  },
  {
    path: '/',
    element: <Navigate to="/agents" replace />,
  },
  {
    path: '/',
    element: (
      <PartnerProtectedRoute>
        <AppShell />
      </PartnerProtectedRoute>
    ),
    children: [
      { path: 'agents', element: <AgentDashboard /> },
      { path: 'agents/new', element: <AgentBuilder /> },
      { path: 'agents/:id', element: <AgentBuilder /> },
      { path: 'profile', element: <ProfilePage /> },
    ],
  },
]);

export default router;
